import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';

const router = createRouter({
	history: createWebHashHistory(),
	routes: [{ path: '/step/:id', component: App }]
});

const target = document.querySelector('#s-app');

if (target) {
	const props = {
		localeSetting: target.dataset.locale,
		isPublicSetting: target.dataset.public !== undefined,
		domainSetting: target.dataset.domain,
		initialData: JSON.parse(target.dataset.initial || 'null')
	};

	createApp(App, props).use(router).mount(target);
}
